const services = [
	"Telecom Infrastructure Installation",
	"IT Infrastructure Installation",
	"ICT Consulting",
	"Networking",
	"Backup Power Installation",
	"Financial Services",
	"Security System",
];

const Services = () => {
	return (
		<div className="bg-slate-950 text-secondary p-10 h-full">
			<h2 className="text-3xl font-semibold text-center">Our Services</h2>
			<div className="grid grid-cols-2 gap-6 mt-6">
				{services.map((service, index) => (
					<div
						key={index}
						className="bg-gray-900 p-6 rounded-lg shadow-lg text-center"
					>
						{service}
					</div>
				))}
			</div>
		</div>
	);
};

export default Services;
